import AutoBtn from './AutoBtn';

export default AutoBtn;
